import React from 'react';
import { Button } from 'react-bootstrap';
import { AiOutlineCheck } from 'react-icons/ai';
import { GiMagnifyingGlass } from 'react-icons/all';
import Carte from './Carte';
import { useGetQuery } from '../../../Utils/api';
import { OptionsData } from '../../Dashboard/Options/Options';

interface Props {
    hasBouton?: boolean;
    boutonOnclick?: () => void;
}

const ForfaitAlaCarte: React.FC<Props> = ({ boutonOnclick, hasBouton }) => {
    const queryActivitesPublics = useGetQuery<number>(['activites', 'countPublic']);
    const nbTotalActivites = useGetQuery<number>(['activites', 'count']);
    const queryAll = useGetQuery<OptionsData>(['options/all']);
    const fraisAnnulationBase = queryAll.data?.frais_annulation_base;

    return (
        <Carte
            style={{ borderRadius: '20px', width: 'auto' }}
            title={'À la carte'}
            subtitle={'Pour des réservations à la pièce'}
            colorsubtitle="gray"
            text={
                <div>
                    <div>
                        <h6>Le service:</h6>
                    </div>
                    <div style={{ marginLeft: '15px', marginBottom: '25px' }}>
                        <span>
                            <AiOutlineCheck></AiOutlineCheck> Accédez à {queryActivitesPublics.data} sur{' '}
                            {nbTotalActivites.data} activités.
                        </span>
                        <br></br>
                        <span>
                            <AiOutlineCheck></AiOutlineCheck> Sélectionnez les activités désirées.
                        </span>
                        <br></br>
                        <span>
                            <AiOutlineCheck></AiOutlineCheck> Consultez les étapes d'une réservation.
                        </span>
                        <br></br>
                        <span>
                            <AiOutlineCheck></AiOutlineCheck> Envoyez une demande de réservation.
                        </span>
                    </div>
                    <div>
                        <h6>Les clauses:</h6>
                    </div>
                    <div style={{ marginLeft: '15px', marginBottom: '25px' }}>
                        <span>
                            <GiMagnifyingGlass></GiMagnifyingGlass> Aucune condition (CE, direction, etc.).
                        </span>
                        <br></br>
                        <span>
                            <GiMagnifyingGlass></GiMagnifyingGlass> Aucun frais de réservation <b>SI</b> l'activité a
                            lieu.
                        </span>
                        <br></br>
                        <span>
                            <GiMagnifyingGlass></GiMagnifyingGlass> Frais d'annulation: à partir de{' '}
                            {fraisAnnulationBase}$ + txs.
                        </span>
                    </div>

                    <div>
                        <h4 style={{ textAlign: 'center', height: '25px', marginBottom: '30px' }}>Gratuit!</h4>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        {hasBouton && (
                            <Button variant="outline-primary" style={{ borderRadius: '20px' }} onClick={boutonOnclick}>
                                Suivant
                            </Button>
                        )}
                    </div>
                </div>
            }
        ></Carte>
    );
};

export default ForfaitAlaCarte;
